'use strict';

var keyMirror = require('keymirror');

var ActionTypes = keyMirror({
  PROJECT_LOAD: null,
  PROJECT_LOAD_REQUEST: null,
  PROJECT_LOAD_DONE: null,
  PROJECT_LOAD_FAIL: null,

  PAGE_LOAD: null,
  PAGE_LOAD_REQUEST: null,
  PAGE_LOAD_DONE: null,
  PAGE_LOAD_FAIL: null,

  PAGE_REDIRECT: null,
  PAGE_REDIRECT_REQUEST: null,
  PAGE_REDIRECT_DONE: null,
  PAGE_REDIRECT_FAIL: null
});

module.exports = ActionTypes;



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/